import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { sessionPackQueryKeys } from "./sessionPackQueryKeys";

export async function sessionPackListQueryFn({
  filter,
  api,
}: {
  filter: Parameters<ApiType["creditPackApi"]["find"]>[0];
  api: ApiType;
}) {
  return (await api.creditPackApi.find({ ...filter })).data;
}

export function useSessionPackList({
  api,
  opts,
}: {
  api: ApiType;
  opts: Parameters<ApiType["creditPackApi"]["find"]>[0];
}) {
  return useQuery({
    queryKey: sessionPackQueryKeys.list(opts),
    queryFn: () => sessionPackListQueryFn({ api, filter: opts }),
  });
}
